"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _context = require("../../context");

var _propTypes = require("../../prop-types");

var _utils = require("../../utils");

var _interfaces = require("../interfaces");

var _constants = require("./constants");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var TableWithoutDocs = (0, _context.styledWithTheme)('table')(function (_ref) {
  var theme = _ref.theme,
      isStriped = _ref.isStriped,
      maxWidth = _ref.maxWidth,
      spacing = _ref.spacing,
      hasStickyHeader = _ref.hasStickyHeader;

  if (!spacing && theme.mode === 'dense') {
    spacing = _interfaces.TableSpacing.Reduced;
  }

  var borderColor = theme.selectors.color(_constants.BORDER_COLOR);
  var headerCSS = {
    backgroundColor: theme.selectors.color(isStriped ? _constants.BACKGROUND_COLOR_HEADER_STRIPED : _constants.BACKGROUND_COLOR_HEADER),
    borderBottom: "".concat(_constants.BORDER_WIDTH_INNER, "px solid ").concat(borderColor)
  };
  var headerVerticalSpacing = (0, _utils.px)(theme.selectors.space(spacing === _interfaces.TableSpacing.Reduced ? _constants.HEADER_SPACING_VERTICAL_REDUCED : _constants.HEADER_SPACING_VERTICAL));
  var verticalSpacing = (0, _utils.px)(theme.selectors.space(spacing === _interfaces.TableSpacing.Reduced ? _constants.CELL_SPACING_VERTICAL_REDUCED : _constants.CELL_SPACING_VERTICAL));
  return _objectSpread(_objectSpread({
    margin: 0,
    padding: 0
  }, !hasStickyHeader && {
    border: "".concat(_constants.BORDER_WIDTH_OUTER, "px solid ").concat(borderColor)
  }), {}, {
    borderCollapse: hasStickyHeader ? 'separate' : 'collapse',
    borderSpacing: 0,
    width: '100%',
    // The 'height' rule ensures table header cells are consistent in
    // height on hover. Removing this rule breaks the outline when hovering
    // over the header cells.
    height: '1px',
    maxWidth: maxWidth,
    fontFamily: theme.selectors.fontFamily('primary'),
    color: theme.selectors.color('neutral90'),
    thead: _objectSpread({}, headerCSS),
    th: {
      paddingTop: headerVerticalSpacing,
      paddingBottom: headerVerticalSpacing
    },
    td: {
      paddingTop: verticalSpacing,
      paddingBottom: verticalSpacing
    }
  });
});
var Table = (0, _stencilReactDesc.describe)(TableWithoutDocs).description("Stencil-styled HTML 'table' element.");
Table.propTypes = {
  isStriped: _stencilReactDesc.PropTypes.bool.description('Changes the background of alternating rows to create a striped pattern.'),
  maxWidth: (0, _propTypes.cssValue)().description("Sets the CSS 'max-width' property for the element."),
  spacing: _stencilReactDesc.PropTypes.oneOf(Object.values(_interfaces.TableSpacing)).description('The amount of inner vertical spacing to use in the table.')
};
Table.displayName = 'Table';
var _default = Table;
exports.default = _default;